import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import styles from "../PartnerAnalyticsDashboard.module.css";

const tooltipStyle = {
  borderRadius: 10,
  border: "none",
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
  background: "#ffffff",
  padding: "10px 12px",
};

const labelStyle = { fontWeight: 800, color: "#0f172a", marginBottom: 6 };
const itemStyle = { color: "#334155", fontWeight: 600 };

const EvolutionChart = ({ points }) => {
  return (
    <div className={styles.chartFrame}>
      <ResponsiveContainer width="100%" height={360}>
        <AreaChart data={points} margin={{ top: 10, right: 24, left: -6, bottom: 0 }}>
          <defs>
            <linearGradient id="zorniVisGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="zorniConvGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1e40af" stopOpacity={0.55} />
              <stop offset="95%" stopColor="#1e40af" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid vertical={false} stroke="#f1f5f9" />
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#94a3b8", fontSize: 12 }}
            dy={10}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#94a3b8", fontSize: 12 }}
          />
          <Tooltip contentStyle={tooltipStyle} labelStyle={labelStyle} itemStyle={itemStyle} />
          <Legend verticalAlign="top" height={30} />

          <Area
            type="monotone"
            dataKey="marketing"
            stackId="1"
            stroke="#94a3b8"
            fill="#cbd5e1"
            name="Événements Marketing"
            isAnimationActive
            animationDuration={900}
          />
          <Area
            type="monotone"
            dataKey="visibility"
            stackId="1"
            stroke="#3b82f6"
            fill="url(#zorniVisGradient)"
            name="Visibilité de l'annonce"
            isAnimationActive
            animationDuration={900}
          />
          <Area
            type="monotone"
            dataKey="conversion"
            stackId="1"
            stroke="#1e40af"
            fill="url(#zorniConvGradient)"
            name="Conversions"
            isAnimationActive
            animationDuration={900}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EvolutionChart;
